let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Lg7Y")).then(() => parcelRequire('fLeOb'));